<template>
  <Playlist
    v-if="videos && videos.length > 0"
    v-bind="{ videos: videosWithId, autoplay, visible }"
    @close="$emit('close')"
    @finished="$emit('finished')"
    @event="$emit('event', $event)"
  />
</template>

<script>
import Playlist from './Playlist';

export default {
  name: 'Playlist_index',
  components: { Playlist },
  props: {
    videos: {},
    autoplay: {},
    visible: {},
  },
  computed: {
    videosWithId() {
      return this.videos.map((v, id) => ({ ...v, id }));
    },
  },
};
</script>



// WEBPACK FOOTER //
// src/components/Playlist/index.vue